import React from "react";
import { Link } from "react-router-dom";
import { isMobile, isIPad13, isTablet } from "react-device-detect";
import { useSelector } from "react-redux";
import BlogPosts from "../../wrappers/blog/BlogPosts";
const isNotMobile = !isMobile || isIPad13 || isTablet;
const AboutUs = () => {
  const aboutUsIntro = () => {
    return (
      <div className=" d-flex flex-column">
        <div className={`section-title text-center  mb-30`}>
          <h2 className="mr-20 color-white">¿Querés conocernos?</h2>
        </div>
        <div
          id="mobile"
          className="d-flex flex-column justify-content-center align-items-center"
        >
          <p className="w-50 sm-w-100 pt-30 color-white">
          Hola! Somos una familia uruguaya que ama pasear y conocer rincones de nuestro querido país.<br /><br />

          Nuestro propósito es conectar familias con paseos, facilitándoles el camino a través de nuestra experiencia
          </p>
          <div className="mt-40 slider-content-2--white slider-animated-1">
            <div
              className="slider-btn btn-hover"
              style={{ position: "inherit" }}
            >
              <Link
                style={{
                  position: "inherit",
                  margin: 0,
                  marginTop: "1rem",
                  border: "none",
                }}
                className="animated rounden-btn"
                to={process.env.PUBLIC_URL + "/about"}
              >
                VER MÁS
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${
            process.env.PUBLIC_URL + "/assets/img/bg/about.jpg"
          })`,
        }}
        className=" welcome-content"
      >
        {aboutUsIntro()}
      </div>
    </>
  );
};

export default AboutUs;